import React from 'react'

function Contract(props) {
	return (
		<svg
			className="icon"
			width="1em"
			height="1em"
			viewBox="0 0 24 24"
			{...props}
		>
			<g
				fill="none"
				fillRule="evenodd"
				strokeLinecap="round"
				stroke="currentColor"
			>
				<path d="M3 15h6v6M21 9h-6V3" />
			</g>
		</svg>
	)
}

const MemoContract = React.memo(Contract)
export default MemoContract
